﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";
import { FileInput } from "../fileinput";

export class FileDropRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var $form = $element.closest('form[data-file-upload]');
    var droppedFile = FileInput.droppedFile;
    var hasFileDrop = !!droppedFile;
    var elementIsFormOrSubmitable = $element.is('input[type="submit"]') || $element.is('form') || $element.is('button');

    var shouldHandle = hasFileDrop && elementIsFormOrSubmitable && $element.isEnabled() && $form.length != 0;
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    var formData = new window['FormData']($form[0] as HTMLFormElement);
    formData.append('droppedFile', droppedFile);

    options.contentType = false;
    options.processData = false;
    options.type = options.type || $element.data('method') || $form.attr('method') || 'post';
    options.url = options.url || $element.data('url') || $form.attr('action');
    options.data = formData;

    Ajax.execute($element, options);
    return true;
  }
}